import { render } from "./Invoices.vue?vue&type=template&id=7d395c76"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Invoices/Invoices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d395c76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d395c76', __exports__)) {
    api.reload('7d395c76', __exports__)
  }
  
  module.hot.accept("./Invoices.vue?vue&type=template&id=7d395c76", () => {
    api.rerender('7d395c76', render)
  })

}


export default __exports__